import { render, staticRenderFns } from "./AdminNavigationTooltip.vue?vue&type=template&id=70b39f68&"
import script from "./AdminNavigationTooltip.vue?vue&type=script&lang=js&"
export * from "./AdminNavigationTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports